module.exports = "/_next/static/images/d2b09be158de82003b5b58a996fd85ae-card-background-right-xs.jpg.webp";